<script>
import { isEmpty } from 'lodash'
import api from '@/helpers/api'
import Multiselect from 'vue-multiselect'

export default {
  name: 'vat-select',
  props: {
    value: { type: Number }
  },
  components: { Multiselect },

  data: vm => ({
    data: [],
    selected: null
  }),
  methods: {
    async loadData () {
      let options = await api.appPreferences.fetchOption('app', 'vat_rates')
      this.data = [...options.map(p => ({ label: `${p}%`, value: p }))]
    },
    onSelected (item) {
      this.$emit('input', item ? item.value : null)
    }
  },
  watch: {
    value: {
      async handler (val, oldVal) {
        if (this.data.length <= 0) {
          await this.loadData()
        }
        this.selected = this.data.find(c => c.value === val)
      },
      immediate: true
    }
  }
}
</script>
<template>
  <Multiselect
    :options="data"
    :searchable="false"
    track-by="value"
    label="label"
    v-model="selected"
    :show-labels="false"
    :allow-empty="false"
    v-bind="$attrs"
    v-on:select="onSelected"
  >
  </Multiselect>
</template>

<style lang="scss">
.multiselect__content-wrapper {
  overflow-x: hidden;
}
</style>
